import { observer } from 'mobx-react-lite'
import { ContentError } from '@/components/ContentError'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import {
  JobInsightsAction,
  JobInsightsCard,
  JobInsightsContent,
  JobInsightsContentSkeleton,
} from '@/features/jobs/details/components/JobInsightsCard'

export interface JobInsightsCardContainerProps {
  vm: JobDetailsViewModel
}

export const JobInsightsCardContainer = observer(
  function JobInsightsCardContainer({ vm }: JobInsightsCardContainerProps) {
    const insightsVm = vm.jobInsightsVm

    const renderInsights = () => (
      <JobInsightsCard
        actions={
          insightsVm.insightsLabelText !== null && (
            <JobInsightsAction
              label={insightsVm.insightsLabelText}
              isPending={insightsVm.regenerateOrGenerateMore.pending}
              onPress={
                insightsVm.isMoreThanZeroMessagesAvailable
                  ? insightsVm.regenerateOrGenerateMore
                  : undefined
              }
            />
          )
        }
      >
        <JobInsightsContent
          latestInsights={insightsVm.latestInsights.map((insight) => ({
            prefixContent: insight.prefixContent,
            generatedResponse: insight.generatedResponse,
          }))}
          isLatestInsightsAvailable={insightsVm.isLatestInsightsAvailable}
          generatedTime={insightsVm.lastGeneratedTimeString}
          isAnyIrrelevant={insightsVm.isAnyIrrelevant}
        />
      </JobInsightsCard>
    )

    return insightsVm.fetch.match({
      pending: () =>
        insightsVm.isRevalidating ? (
          renderInsights()
        ) : (
          <JobInsightsCard actions={<JobInsightsAction isPending />}>
            <JobInsightsContentSkeleton />
          </JobInsightsCard>
        ),
      rejected: (err) => (
        <JobInsightsCard>
          <ContentError
            size="section"
            title="An error occurred while loading the job insights."
            error={err}
          />
        </JobInsightsCard>
      ),
      resolved: renderInsights,
    })
  },
)
